import { render, staticRenderFns } from "./PortalBrand.vue?vue&type=template&id=6cbca754&scoped=true&"
import script from "./PortalBrand.vue?vue&type=script&lang=js&"
export * from "./PortalBrand.vue?vue&type=script&lang=js&"
import style0 from "./PortalBrand.vue?vue&type=style&index=0&id=6cbca754&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbca754",
  null
  
)

export default component.exports